<template>
  <div class="offer-container offer-table2">
    <LandingBarFSP active="trading" />
    <div class="offer-inner-container">
      <v-breadcrumbs :items="bread" divider=">"></v-breadcrumbs>
      <div class="table-top-flex">
        <h3 class="table-headline">Requests</h3>
        <v-text-field
          v-model="search"
          outlined
          label="Search company code, table, or address"
          class="search-field"
          hide-details
          background-color="#fff"
          :prepend-inner-icon="icons.mdiMagnify"
        >
          <template v-slot:append class="append-button">
            <v-btn depressed tile color="#58c26d" class="search-button" large>
              Search
            </v-btn>
          </template></v-text-field
        >

        <v-dialog v-model="dialog" width="740" class="modal">
          <!-- <template v-slot:activator="{ on, attrs }">
            <div class="offer-button-wrapper">
              <v-btn
                depressed
                tile
                color="#58c26d"
                class="search-button"
                large
                v-bind="attrs"
                v-on="on"
              >
                <v-icon left>{{ icons.mdiPlus }}</v-icon
                >Add request
              </v-btn>
            </div>
          </template> -->

          <v-card class="add-dialog-window">
            <div class="modal-wrapper">
              <div class="cancel-button-wrapper">
                <div class="cancel-button-text" @click="dialog = false">
                  Cancel
                </div>
              </div>
              <h1 class="modal-header">Add request</h1>

              <div class="modal-button-wrapper">
                <v-btn
                  :loading="loading"
                  :disabled="loading"
                  depressed
                  tile
                  color="#58c26d"
                  class="modal-button"
                  large
                >
                  <a href="/request/uploadRequestsAdmin/"
                    >Upload requests from Excel file</a
                  >
                </v-btn>
              </div>

              <v-row class="modal-row">
                <v-divider></v-divider><span class="modal-text">or</span
                ><v-divider></v-divider>
              </v-row>

              <div class="modal-subheader">Please fill out the form below</div>
              <div class="form-group">
                <div class="form-flex">
                  <div class="column2 reqlocationClass">
                    <v-select
                      v-model="request.locationCode"
                      class="bottom-margin2"
                      label="Location"
                      color="#58c26d"
                      hide-details
                      :items="locations"
                      item-text="locationName"
                      item-value="locationCode"
                      dense
                      outlined
                    ></v-select>
                  </div>
                  <div class="column2 reqcompanyType">
                    <v-select
                      v-model="request.dayType"
                      class="bottom-margin2"
                      color="#58c26d"
                      label="When"
                      hide-details
                      :items="days"
                      dense
                      outlined
                    ></v-select>
                  </div>
                </div>
              </div>

              <div class="form-group">
                <div class="form-flex">
                  <div class="column2">
                    <v-menu
                      ref="menu"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      full-width
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          class="bottom-margin2"
                          hide-details
                          color="#58c26d"
                          v-model="request.dateFrom"
                          v-on="on"
                          label="Date from"
                          id="reqdateFrom"
                          append-icon="mdi-menu-down"
                          dense
                          outlined
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        ref="picker"
                        color="#329e5e"
                        @input="(e) => changeDateFrom(e)"
                      ></v-date-picker>
                    </v-menu>
                  </div>
                  <div class="column2">
                    <v-menu
                      ref="menu"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      full-width
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          class="bottom-margin2"
                          hide-details
                          color="#58c26d"
                          v-model="request.dateTo"
                          v-on="on"
                          label="Date to"
                          id="reqdateTo"
                          append-icon="mdi-menu-down"
                          dense
                          outlined
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        ref="picker"
                        color="#329e5e"
                        @input="(e) => changeDateTo(e)"
                      ></v-date-picker>
                    </v-menu>
                  </div>
                </div>
              </div>

              <div class="form-group">
                <div class="form-flex">
                  <div class="column2">
                    <v-menu
                      ref="menu2"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      full-width
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          class="bottom-margin2"
                          label="Time from"
                          id="reqtimeFrom"
                          color="#58c26d"
                          v-model="request.timeFrom"
                          hide-details
                          append-icon="mdi-menu-down"
                          dense
                          outlined
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-time-picker
                        ref="tpicker"
                        color="#329e5e"
                        @input="(e) => changeTimeFrom(e)"
                      ></v-time-picker>
                    </v-menu>
                  </div>
                  <div class="column2">
                    <v-menu
                      ref="menu2"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      full-width
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          class="bottom-margin2"
                          label="Time to"
                          id="reqtimeTo"
                          color="#58c26d"
                          v-model="request.timeTo"
                          hide-details
                          append-icon="mdi-menu-down"
                          dense
                          outlined
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-time-picker
                        ref="tpicker"
                        color="#329e5e"
                        @input="(e) => changeTimeTo(e)"
                      ></v-time-picker>
                    </v-menu>
                  </div>
                </div>
              </div>

              <div class="form-group">
                <div class="form-flex">
                  <div class="column2">
                    <v-text-field
                      type="number"
                      outlined
                      color="#58c26d"
                      dense
                      hide-details
                      label="Volume (KWh)"
                      id="reqvolume"
                      v-model="request.volume"
                      class="bottom-margin2"
                    />
                  </div>
                  <div class="column2">
                    <v-text-field
                      type="number"
                      color="#58c26d"
                      outlined
                      dense
                      hide-details
                      label="Price (c€/KWh)"
                      id="reqprice"
                      v-model="request.price"
                      class="bottom-margin2"
                    />
                  </div>
                </div>
              </div>
              <div class="form-group">
                <div class="form-flex">
                  <div class="column2">
                    <v-menu
                      ref="menu"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      full-width
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          class="bottom-margin2"
                          hide-details
                          color="#58c26d"
                          v-model="request.deadline"
                          v-on="on"
                          label="Deadline"
                          append-icon="mdi-menu-down"
                          dense
                          outlined
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        ref="picker"
                        color="#329e5e"
                        @input="(e) => changeDeadline(e)"
                      ></v-date-picker>
                    </v-menu>
                  </div>
                </div>
              </div>
            </div>

            <div class="modal-button-wrapper">
              <v-btn
                :loading="loading"
                :disabled="loading"
                depressed
                tile
                color="#58c26d"
                class="modal-button"
                large
                v-on:click="saveRequest"
              >
                Add request
              </v-btn>
            </div>
          </v-card>
        </v-dialog>

        <v-dialog v-model="edit" width="740" class="modal">
          <v-card class="add-dialog-window">
            <div class="modal-wrapper">
              <div class="cancel-button-wrapper">
                <div class="cancel-button-text" @click="edit = false">
                  Cancel
                </div>
              </div>
              <h1 class="modal-header">Edit request</h1>
              <div class="modal-subheader">Please fill out the form below</div>
              <div class="form-group">
                <div class="form-flex">
                  <div class="column2">
                    <v-select
                      v-model="currentRequest.locationCode"
                      class="bottom-margin2"
                      label="Location"
                      color="#58c26d"
                      hide-details
                      :items="locations"
                      item-text="locationName"
                      item-value="locationCode"
                      dense
                      outlined
                    >
                    </v-select>
                    <!-- <div
                      v-if="errors.has('companyName')"
                      class="alert alert-danger"
                      role="alert"
                    >
                      Company Name is required!
                    </div> -->
                  </div>
                  <div class="column2">
                    <v-select
                      v-model="currentRequest.dayType"
                      class="bottom-margin2"
                      color="#58c26d"
                      label="When"
                      hide-details
                      :items="days"
                      dense
                      outlined
                    ></v-select>
                    <!-- <div
                      v-if="errors.has('companyType')"
                      class="alert alert-danger"
                      role="alert"
                    >
                      <font color="#a41517">Company Type is required!</font>
                    </div> -->
                  </div>
                </div>
              </div>

              <div class="form-group">
                <div class="form-flex">
                  <div class="column2">
                    <v-menu
                      ref="menu"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      full-width
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          class="bottom-margin2"
                          hide-details
                          color="#58c26d"
                          v-model="currentRequest.dateFrom"
                          v-on="on"
                          label="Date from"
                          append-icon="mdi-menu-down"
                          dense
                          outlined
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        ref="picker"
                        color="#329e5e"
                        @input="(e) => changeEditDateFrom(e)"
                      ></v-date-picker>
                    </v-menu>
                    <!-- <div
                      v-if="errors.has('email')"
                      class="alert alert-danger"
                      role="alert"
                    >
                      <font color="#a41517">Email is required!</font>
                    </div>
                    <div
                      v-if="submitted && errors.has('email')"
                      class="alert-danger"
                    >
                      {{ errors.first("email") }}
                    </div> -->
                  </div>
                  <div class="column2">
                    <v-menu
                      ref="menu"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      full-width
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          class="bottom-margin2"
                          hide-details
                          color="#58c26d"
                          v-model="currentRequest.dateTo"
                          v-on="on"
                          label="Date to"
                          append-icon="mdi-menu-down"
                          dense
                          outlined
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        ref="picker"
                        color="#329e5e"
                        @input="(e) => changeEditDateTo(e)"
                      ></v-date-picker>
                    </v-menu>
                    <!-- <div
                      v-if="errors.has('password')"
                      class="alert alert-danger"
                      role="alert"
                    >
                      <font color="#a41517">Password is required!</font>
                    </div>
                    <div
                      v-if="submitted && errors.has('password')"
                      class="alert-danger"
                    >
                      {{ errors.first("password") }}
                    </div> -->
                  </div>
                </div>
              </div>
              <div class="form-group">
                <div class="form-flex">
                  <div class="column2">
                    <v-menu
                      ref="menu2"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      full-width
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          class="bottom-margin2"
                          label="Time from"
                          color="#58c26d"
                          v-model="currentRequest.timeFrom"
                          hide-details
                          append-icon="mdi-menu-down"
                          dense
                          outlined
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-time-picker
                        ref="tpicker"
                        color="#329e5e"
                        @input="(e) => changeEditTimeFrom(e)"
                      ></v-time-picker>
                    </v-menu>
                    <!-- <div
                      v-if="errors.has('companyAddress')"
                      class="alert alert-danger"
                      role="alert"
                    >
                      Street Name is required!
                    </div> -->
                  </div>
                  <div class="column2">
                    <v-menu
                      ref="menu2"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      full-width
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          class="bottom-margin2"
                          label="Time to"
                          color="#58c26d"
                          v-model="currentRequest.timeTo"
                          hide-details
                          append-icon="mdi-menu-down"
                          dense
                          outlined
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-time-picker
                        ref="tpicker"
                        color="#329e5e"
                        @input="(e) => changeEditTimeTo(e)"
                      ></v-time-picker>
                    </v-menu>
                    <!-- <div
                      v-if="errors.has('buildingNumber')"
                      class="alert alert-danger"
                      role="alert"
                    >
                      Street Name is required!
                    </div> -->
                  </div>
                </div>
              </div>
              <div class="form-group">
                <div class="form-flex">
                  <div class="column2">
                    <v-text-field
                      type="number"
                      outlined
                      color="#58c26d"
                      dense
                      hide-details
                      label="Volume (KWh)"
                      v-model="currentRequest.volume"
                      class="bottom-margin2"
                    />
                    <!-- <div
                      v-if="errors.has('city')"
                      class="alert alert-danger"
                      role="alert"
                    >
                      City Name is required!
                    </div> -->
                  </div>
                  <div class="column2">
                    <v-text-field
                      type="number"
                      color="#58c26d"
                      outlined
                      dense
                      hide-details
                      label="Price (&euro;/KWh)"
                      v-model="currentRequest.price"
                      class="bottom-margin2"
                    />
                    <!-- <div
                      v-if="errors.has('postcode')"
                      class="alert alert-danger"
                      role="alert"
                    >
                      Postcode is required!
                    </div> -->
                  </div>
                </div>
              </div>
              <div class="form-group">
                <div class="form-flex">
                  <div class="column2">
                    <v-menu
                      ref="menu"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      full-width
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          class="bottom-margin2"
                          hide-details
                          color="#58c26d"
                          v-model="currentRequest.deadline"
                          v-on="on"
                          label="Deadline"
                          append-icon="mdi-menu-down"
                          dense
                          outlined
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        ref="picker"
                        color="#329e5e"
                        @input="(e) => changeEditDeadline(e)"
                      ></v-date-picker>
                    </v-menu>
                    <!-- <div
                      v-if="errors.has('phoneNumber')"
                      class="alert alert-danger"
                      role="alert"
                    >
                      Phone Number is required!
                    </div> -->
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-button-wrapper">
              <v-btn
                :loading="loading"
                :disabled="loading"
                depressed
                tile
                color="#58c26d"
                class="modal-button"
                large
                v-on:click="updateRequest"
              >
                Save request
              </v-btn>
            </div>
          </v-card>
        </v-dialog>
      </div>

      <div class="offer-table-wrapper2">
        <table hidden class="offer-table">
          <tr>
            <th>Location</th>
            <th>When</th>
            <th>Date from</th>
            <th>Date to</th>
            <th>From</th>
            <th>To</th>
            <th>Volume (MW<span class="lowercase">h</span>)</th>
            <th>Price (&euro;\MW<span class="lowercase">h</span>)</th>
            <th>Deadline</th>
            <th style="text-align: center">Action</th>
          </tr>
          <tr
            :class="{ active: index == currentIndex }"
            v-for="(request, index) in requests"
            :key="index"
            @click="setActiveRequest(offer, index)"
          >
            <td>{{ request.locationCode }}</td>
            <td>{{ request.dayType }}</td>
            <td>{{ request.dateFrom }}</td>
            <td>{{ request.dateTo }}</td>
            <td>{{ request.timeFrom }}</td>
            <td>{{ request.timeTo }}</td>
            <td style="text-align: center">{{ request.volume }}</td>
            <td style="text-align: center">{{ request.price }}</td>
            <td>{{ request.deadline }}</td>
            <!-- <td style="text-align:center">
              <a class="table-button" :href="'/request/requests/' + request.id">Edit</a> |
              <button
                sec:authorize="hasAuthority('ADMIN')"
                class="table-button"
                @click="deleteRequest(request.id)"
              >Delete</button>
            </td> -->
          </tr>
        </table>

        <!-- <div class="offer-table">
          <vue-good-table
            :columns="columns"
            :rows="requests"
            :search-options="{ enabled: true }"
          >
            <div slot="selected-row-actions">
              <button>Action 1</button>
            </div>
          </vue-good-table>
        </div> -->
        <v-data-table
          :header-props="{ sortIcon: icons.mdiArrowUpBold }"
          :headers="headers"
          :items="requests"
          :search="search"
        >
          <template v-slot:item.status="{ item }">
            <div>{{ statuses[item.status] }}</div>
          </template>
          <!-- <template v-slot:item.id="{ item }">
            <v-btn
              class="edit-button"
              plain
              color="#58c26d"
              v-on:click="() => getRequest(item.id)"
              >Edit</v-btn
            >
          </template> -->
        </v-data-table>
      </div>
    </div>
  </div>
</template>

<script>
import RequestDataService from "../../services/RequestDataService";
import LandingBarFSP from "../../components/Common/LandingBarFSP.vue";
import LocationDataService from "../../services/LocationDataService";

import { VueGoodTable } from "vue-good-table";
import "vue-good-table/dist/vue-good-table.css";
import { mdiMagnify, mdiPlus, mdiArrowUpBold } from "@mdi/js";

export default {
  name: "requests-list",
  components: { LandingBarFSP, VueGoodTable },
  data() {
    return {
      locations: [],
      days: ["weekdays", "weekends", "alldays"],
      loading: false,
      edit: false,
      search: "",
      dialog: false,
      icons: {
        mdiMagnify,
        mdiPlus,
        mdiArrowUpBold,
      },
      bread: [
        {
          text: "Trading",
          disabled: false,
          href: "/dashboardAdmin",
        },
        {
          text: "Requests",
          disabled: false,
        },
      ],
      statuses: {
        1: "Active",
        2: "Sold",
        3: "Expired",
        4: "Closed",
      },
      headers: [
        {
          text: "Location",
          align: "start",
          value: "locationCode",
        },
        { text: "Status", value: "status" },
        { text: "When", value: "dayType" },
        { text: "Date from", value: "dateFrom" },
        { text: "Date to", value: "dateTo" },
        { text: "Time from", value: "timeFrom" },
        { text: "Time to", value: "timeTo" },
        { text: "Volume", value: "volume" },
        { text: "Price", value: "price" },
        { text: "Deadline", value: "deadline" },
        { text: "Grid node", value: "gridNode" },
      ],
      currentRequest: {
        id: null,
        companyCode: this.$store.state.auth.user.companyCode,
        requestCode: "",
        locationCode: "",
        dayType: "",
        dateFrom: "",
        dateTo: "",
        timeFrom: "",
        timeTo: "",
        volume: "",
        price: "",
        deadline: "",
      },
      request: {
        id: null,
        companyCode: this.$store.state.auth.user.companyCode,
        requestCode: "",
        locationCode: "",
        dayType: "",
        dateFrom: "",
        dateTo: "",
        timeFrom: "",
        timeTo: "",
        volume: "",
        price: "",
        deadline: "",
      },
      requests: [
        /* {
          id: 1,
          locationCode: "Sofia City",
          dayType: "Weekends",
          dateFrom: "30/08/2020",
          dateTo: "02/09/2020",
          timeFrom: "10:00",
          timeTo: "18:00",
          volume: "10KWh",
          price: "30.00",
          deadline: "01/09/2020"
        },
        {
          id: 2,
          locationCode: "Pleven",
          dayType: "Weekday",
          dateFrom: "30/08/2020",
          dateTo: "02/09/2020",
          timeFrom: "10:00",
          timeTo: "18:00",
          volume: "40KWh",
          price: "60.00",
          deadline: "01/09/2020"
        },
        {
          id: 3,
          locationCode: "Sofia",
          dayType: "Weekends",
          dateFrom: "30/08/2020",
          dateTo: "02/09/2020",
          timeFrom: "10:00",
          timeTo: "18:00",
          volume: "10KWh",
          price: "30.00",
          deadline: "01/09/2020"
        },
        {
          id: 4,
          locationCode: "Montana",
          dayType: "Weekends",
          dateFrom: "30/08/2020",
          dateTo: "02/09/2020",
          timeFrom: "10:00",
          timeTo: "18:00",
          volume: "30KWh",
          price: "50.00",
          deadline: "01/09/2020"
        }, */
      ],
      currentIndex: -1,
      compapyCode: "",

      locations: [],
      dayTypes: [],
      dateFroms: [],
      dateTos: [],
      timeFroms: [],
      timeTos: [],
      volumes: [],
      prices: [],
      deadlines: [],
    };
  },
  methods: {
    changeDeadline(e) {
      this.request.deadline = e;
    },
    changeTimeFrom(e) {
      this.request.timeFrom = e;
    },
    changeTimeTo(e) {
      this.request.timeTo = e;
    },
    changeDateFrom(e) {
      this.request.dateFrom = e;
    },
    changeDateTo(e) {
      this.request.dateTo = e;
    },
    changeEditDeadline(e) {
      this.currentRequest.deadline = e;
    },
    changeEditTimeFrom(e) {
      this.currentRequest.timeFrom = e;
    },
    changeEditTimeTo(e) {
      this.currentRequest.timeTo = e;
    },
    changeEditDateFrom(e) {
      this.currentRequest.dateFrom = e;
    },
    changeEditDateTo(e) {
      this.currentRequest.dateTo = e;
    },
    async saveRequest() {
      this.loading = true;
      var data = {
        companyCode: this.request.companyCode,
        requestCode: this.request.requestCode,
        locationCode: this.request.locationCode,
        dayType: this.request.dayType,
        dateFrom: this.request.dateFrom,
        dateTo: this.request.dateTo,
        timeFrom: this.request.timeFrom,
        timeTo: this.request.timeTo,
        volume: this.request.volume,
        price: this.request.price,
        deadline: this.request.deadline,
      };
      await this.Apps.registerRequest();
      this.loading = false;
      if (await this.savedToBlock) {
        RequestDataService.create(data)
          .then((response) => {
            this.$store.commit("change", false);
            this.submitted = true;
            this.retrieveRequests();
            this.loading = false;
            this.dialog = false;
          })
          .catch((e) => {
            console.log(e);
          });
      }
    },
    async updateRequest() {
      this.loading = true;
      await this.Apps.updateFlexRequest();
      RequestDataService.update(this.currentRequest.id, this.currentRequest)
        .then((response) => {
          this.$store.commit("change", false);
          console.log(response.data);
          this.retrieveRequests();
          this.loading = false;
          this.edit = false;
        })
        .catch((e) => {
          console.log(e);
        });
    },
    retrieveLocations(countryCode) {
      LocationDataService.findBySubCountryCode(countryCode)
        .then((response) => {
          this.locations = response.data;
        })
        .catch((e) => {
          console.log("HERE... load locations zones error: " + e);
        });
    },
    importRequests() {
      var data = {
        companyCode: this.request.companyCode,
        requestCode: this.request.requestCode,
        locationCode: this.request.locationCode,
        dateFrom: this.request.dateFrom,
        dateTo: this.request.dateTo,
        timeFrom: this.request.timeFrom,
        timeTo: this.request.timeTo,
        volume: this.request.volume,
        price: this.request.price,
        deadline: this.request.deadline,
      };

      RequestDataService.import(data)
        .then((response) => {
          this.request.id = response.data.id;
          console.log(response.data);
          this.submitted = true;
          this.$router.push({ name: "requests" });
        })
        .catch((e) => {
          console.log(e);
        });
    },
    retrieveRequests() {
      console.log(
        "HERE... currentUser's role: " + this.$store.state.auth.user.roles
      );
      if (
        this.$store.state.auth.user.roles == "ROLE_ADMIN" &&
        this.$store.state.auth.user.countryCode == "BE"
      ) {
        RequestDataService.getAll()
          .then((response) => {
            this.requests = response.data;
            console.log(
              "HERE... retrieve Requests resucessfull: " + response.data
            );
            for (var i = 0; i < this.requests.length; i++) {
              if (this.locations.indexOf(this.requests[i].locationCode) == -1) {
                this.locations.push(this.requests[i].locationCode);
              }
              if (this.dayTypes.indexOf(this.requests[i].dayType) == -1) {
                this.dayTypes.push(this.requests[i].dayType);
              }
              if (this.dateFroms.indexOf(this.requests[i].dateFrom) == -1) {
                this.dateFroms.push(this.requests[i].dateFrom);
              }
              if (this.dateTos.indexOf(this.requests[i].dateTo) == -1) {
                this.dateTos.push(this.requests[i].dateTo);
              }
              if (this.timeFroms.indexOf(this.requests[i].timeFrom) == -1) {
                this.timeFroms.push(this.requests[i].timeFrom);
              }
              if (this.timeTos.indexOf(this.requests[i].timeTo) == -1) {
                this.timeTos.push(this.requests[i].timeTo);
              }
              if (this.volumes.indexOf(this.requests[i].volume) == -1) {
                this.volumes.push(this.requests[i].volume);
              }
              if (this.prices.indexOf(this.requests[i].price) == -1) {
                this.prices.push(this.requests[i].price);
              }
              if (this.prices.indexOf(this.requests[i].deadline) == -1) {
                this.prices.push(this.requests[i].deadline);
              }

              console.log("HERE... request: " + this.requests[i]["id"]);
              //var btn = "<button class='table-button'>Edit</button>"
              var btn = `<a href="/request/requestsAdmin/' +
                this.requests[i]["id"] +
                '">Edit</a>`;
              this.requests[i]["btn"] = btn;
              console.log("HERE... request with action: " + btn);
            }
            this.locations.sort();
            this.dayTypes.sort();
            this.dateFroms.sort();
            this.dateTos.sort();
            this.timeFroms.sort();
            this.timeTos.sort();
            this.volumes.sort();
            this.prices.sort();
            this.deadlines.sort();
          })
          .catch((e) => {
            console.log("HERE... retrieve Requests error: " + e);
          });
      } else {
        console.log(
          "HERE... currentUser's countryCode: " +
            this.$store.state.auth.user.countryCode
        );
        RequestDataService.findByCountryCode(
          this.$store.state.auth.user.countryCode
        )
          .then((response) => {
            this.requests = response.data;
            console.log(
              "HERE... retrieve Requests resucessfull: " + response.data
            );
            for (var i = 0; i < this.requests.length; i++) {
              if (this.locations.indexOf(this.requests[i].locationCode) == -1) {
                this.locations.push(this.requests[i].locationCode);
              }
              if (this.dayTypes.indexOf(this.requests[i].dayType) == -1) {
                this.dayTypes.push(this.requests[i].dayType);
              }
              if (this.dateFroms.indexOf(this.requests[i].dateFrom) == -1) {
                this.dateFroms.push(this.requests[i].dateFrom);
              }
              if (this.dateTos.indexOf(this.requests[i].dateTo) == -1) {
                this.dateTos.push(this.requests[i].dateTo);
              }
              if (this.timeFroms.indexOf(this.requests[i].timeFrom) == -1) {
                this.timeFroms.push(this.requests[i].timeFrom);
              }
              if (this.timeTos.indexOf(this.requests[i].timeTo) == -1) {
                this.timeTos.push(this.requests[i].timeTo);
              }
              if (this.volumes.indexOf(this.requests[i].volume) == -1) {
                this.volumes.push(this.requests[i].volume);
              }
              if (this.prices.indexOf(this.requests[i].price) == -1) {
                this.prices.push(this.requests[i].price);
              }
              if (this.prices.indexOf(this.requests[i].deadline) == -1) {
                this.prices.push(this.requests[i].deadline);
              }

              console.log("HERE... request: " + this.requests[i]["id"]);
              //var btn = "<button class='table-button'>Edit</button>"
              var btn =
                '<a href="/request/requestsAdmin/' +
                this.requests[i]["id"] +
                '">Edit</a>';
              this.requests[i]["btn"] = this.requests[i]["id"];
              console.log("HERE... request with action: " + btn);
            }
            this.locations.sort();
            this.dayTypes.sort();
            this.dateFroms.sort();
            this.dateTos.sort();
            this.timeFroms.sort();
            this.timeTos.sort();
            this.volumes.sort();
            this.prices.sort();
            this.deadlines.sort();
          })
          .catch((e) => {
            console.log("HERE... retrieve Requests error: " + e);
          });
      }

      /* RequestDataService.getAll()
        .then((response) => {
          this.requests = response.data;
          console.log("HERE... retrieve Requests resucessfull: " + response.data);
          for (var i = 0; i < this.requests.length; i++) {
            if (this.locations.indexOf(this.requests[i].locationCode) == -1) {
              this.locations.push(this.requests[i].locationCode)
            }
            if (this.dayTypes.indexOf(this.requests[i].dayType) == -1) {
              this.dayTypes.push(this.requests[i].dayType)
            }
            if (this.dateFroms.indexOf(this.requests[i].dateFrom) == -1) {
              this.dateFroms.push(this.requests[i].dateFrom)
            }
            if (this.dateTos.indexOf(this.requests[i].dateTo) == -1) {
              this.dateTos.push(this.requests[i].dateTo)
            }
            if (this.timeFroms.indexOf(this.requests[i].timeFrom) == -1) {
              this.timeFroms.push(this.requests[i].timeFrom)
            }
            if (this.timeTos.indexOf(this.requests[i].timeTo) == -1) {
              this.timeTos.push(this.requests[i].timeTo)
            }
            if (this.volumes.indexOf(this.requests[i].volume) == -1) {
              this.volumes.push(this.requests[i].volume)
            }
            if (this.prices.indexOf(this.requests[i].price) == -1) {
              this.prices.push(this.requests[i].price)
            }
            if (this.prices.indexOf(this.requests[i].deadline) == -1) {
              this.prices.push(this.requests[i].deadline)
            }
            
            console.log("HERE... request: " + this.requests[i]["id"]);
            //var btn = "<button class='table-button'>Edit</button>"
            var btn = '<a href="/request/requests/'+this.requests[i]["id"]+'">Edit</a>'
            this.requests[i]["btn"] = btn
            console.log("HERE... request with action: " + btn)
          }
          this.locations.sort();
          this.dayTypes.sort();
          this.dateFroms.sort();
          this.dateTos.sort();
          this.timeFroms.sort();
          this.timeTos.sort();
          this.volumes.sort();
          this.prices.sort();
          this.deadlines.sort();
        })
        .catch((e) => {
          console.log("HERE... retrieve Requests error: " + e);
        }); */
    },

    refreshList() {
      this.retrieveRequests();
      this.currentRequest = null;
      this.currentIndex = -1;
    },

    setActiveRequest(request, index) {
      this.currentRequest = request;
      this.currentIndex = index;
    },

    deleteRequest(id) {
      RequestDataService.delete(id)
        .then((response) => {
          console.log(response.data);
          this.refreshList();
        })
        .catch((e) => {
          console.log(e);
        });
    },

    removeAllRequests() {
      RequestDataService.deleteAll()
        .then((response) => {
          console.log(response.data);
          this.refreshList();
        })
        .catch((e) => {
          console.log(e);
        });
    },

    searchCompanyCode() {
      RequestDataService.findByCompanyCode(this.companyCode)
        .then((response) => {
          this.requests = response.data;
          console.log(response.data);
        })
        .catch((e) => {
          console.log(e);
        });
    },
    getColumns() {
      this.columns = [
        {
          label: "Location",
          field: "locationCode",
          thClass: "text-center",
          tdClass: "text-center",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter by Location", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: this.locations,
            filterFn: this.columnFilterFn, //custom filter function that
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: "When",
          field: "dayType",
          thClass: "text-center",
          tdClass: "text-center",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter by day type", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: this.dayTypes,
            filterFn: this.columnFilterFn, //custom filter function that
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: "Date from",
          field: "dateFrom",
          thClass: "text-center",
          tdClass: "text-center",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter by Date from", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [],
            filterFn: this.columnFilterFn, //custom filter function that
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: "Date to",
          field: "dateTo",
          thClass: "text-center",
          tdClass: "text-center",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter by Date to", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [],
            filterFn: this.columnFilterFn, //custom filter function that
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: "Time from",
          field: "timeFrom",
          thClass: "text-center",
          tdClass: "text-center",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter by Time from", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [],
            filterFn: this.columnFilterFn, //custom filter function that
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: "Time to",
          field: "timeTo",
          thClass: "text-center",
          tdClass: "text-center",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter by Time to", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: this.cities,
            filterFn: this.columnFilterFn, //custom filter function that
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: "Volume (KWh)",
          field: "volume",
          type: "number",
          thClass: "text-center",
          tdClass: "text-center",
          /*
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: 'Filter by Volume', // placeholder for filter input
            filterValue: '', // initial populated value for this filter
            filterDropdownItems: this.volumes,
            filterFn: this.columnFilterFn, //custom filter function that
            trigger: 'enter', //only trigger on enter not on keyup 
          },
          */
        },
        {
          label: "Price   (c€\\KWh)",
          field: "price",
          type: "number",
          thClass: "text-center",
          tdClass: "text-center",
          /*
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: 'Filter by Price', // placeholder for filter input
            filterValue: '', // initial populated value for this filter
            filterDropdownItems: this.prices,
            filterFn: this.columnFilterFn, //custom filter function that
            trigger: 'enter', //only trigger on enter not on keyup 
          },
          */
        },
        {
          label: "Deadline",
          field: "deadline",
          thClass: "text-center",
          tdClass: "text-center",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter by Deadline", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: this.deadlines,
            filterFn: this.columnFilterFn, //custom filter function that
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: "Action",
          thClass: "text-center",
          tdClass: "text-center",
          field: "btn",
          html: true,
          sortable: false,
        },
      ];
      return this.columns;
    },

    getRequest(id) {
      RequestDataService.get(id)
        .then((response) => {
          this.currentRequest = response.data;
          this.edit = true;
          console.log("WOOOOO", this.currentRequest);
        })
        .catch((e) => {
          console.log(e);
        });
    },
  },
  mounted() {
    this.retrieveRequests();
    this.getColumns();
    this.retrieveLocations(this.$store.state.auth.user.countryCode);
  },
};
</script>

<style lang="scss">
@import "../../sass/main.scss";

.nav-bar {
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.2);
}

.offer-container {
  min-height: 100vh;
  background: #f8fcff;
  margin-top: -100px;
  margin-left: -10px;
}

.offer-inner-container {
  padding: 40px;
}

.top-offer-table-bar {
  background: #f9fafe;
  padding: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #f0f3fb;
}

.offer-search-wrapper {
  display: flex;
  align-items: center;
  width: 30%;
  max-width: 300px;
}

.offer-input {
  display: inline-block;
  font-size: 0.9rem;
  color: $black;
  line-height: 1.3;
  padding: 0.6em 0.4em 0.5em 0.8em;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  margin: 0 10px 0 0;
  border: 1px solid #aaa;
  box-shadow: 0 1px 0 1px rgba(0, 0, 0, 0.04);
  border-radius: 0.1em;
  -moz-appearance: none;
  -webkit-appearance: none;
  appearance: none;
}

.offer-input:focus,
.offer-search-button:focus {
  outline: none;
  border: 1px solid #6680a0;
  box-shadow: 0 0 5px #c8d2da;
}

.offer-search-button {
  font-size: 0.9rem;
  color: $black;
  padding: 6px 15px;
  background: #fff;
  border: 1px solid #aaa;
  box-shadow: 0 1px 0 1px rgba(0, 0, 0, 0.04);
}

.offer-add-button {
  font-size: 0.9rem;
  color: $black;
  padding: 6px 15px;
  background: #bfecb5;
  border: 1px solid #aaa;
  box-shadow: 0 1px 0 1px rgba(0, 0, 0, 0.04);
  margin-right: 10px;
}

.offer-remove-button {
  font-size: 0.9rem;
  color: $black;
  padding: 6px 15px;
  background: #f8736b;
  border: 1px solid #aaa;
  box-shadow: 0 1px 0 1px rgba(0, 0, 0, 0.04);
}

.offer-table {
  background: #fff;
  width: 100%;
}

.offer-table th {
  color: #4a4a4a;
  font-size: 16px;
  //text-transform: uppercase;
  font-weight: 600px;
  padding: 15px;
  text-align: left;
  border-bottom: 1px solid #e6e6e6;
}

.offer-table td {
  color: #4a4a4a;
  font-size: 14px;
  font-weight: 600px;
  padding: 15px;
  text-align: left;
  border-bottom: 1px solid #e6e6e6;
}

.offer-table tr:hover {
  background: #f5f8fd;
}

.table-button {
  background: none;
  border: none;
  padding: 0 5px;
  color: #007bff;
}

.table-button:hover {
  text-decoration: underline;
  color: #007bff;
}

.list {
  text-align: left;
  max-width: 750px;
  margin: auto;
}
</style>
